import { GET_LOSTMEMBER_INFO_LOADING, LOSTMEMBER_DATA_SUCCESS, LOSTMEMBER_DATA_ERROR } from "../actions/actionLostMember";
import { put, takeEvery } from 'redux-saga/effects';
import { apiLostMember } from 'api';

async function fetchAsync(func, param) {
    const response = await func(param);

    if (response.ok && response.status == 200) {
        return await response.json();
    }
    else if (response.status == 204) {
        return "nocontent";
    }
    if (response.status == 400) {
        let error = await response.json();
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"" + error.Errors[0].ErrorMessage.replace('Error: ', '') + " response status: " + response.status + "\"}]}")
    }
    else {
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to Send Email, response status: " + response.status + "\"}]}")
    }
}

function* fetchLostMemberData(action) {
    try {
        const data = yield fetchAsync(apiLostMember, action.payload)
        yield put({ type: LOSTMEMBER_DATA_SUCCESS, payload: data });
    } catch (e) {
        yield put({ type: LOSTMEMBER_DATA_ERROR, error: e.Errors[0].ErrorMessage });
    }
}

export const sagaLostMember = [
    takeEvery(GET_LOSTMEMBER_INFO_LOADING, fetchLostMemberData)
];
